/* global messg */
import { kea } from 'kea'
import { put } from 'redux-saga/effects'

import I18n from 'lib/i18n'

import Bugsnag from '~/scenes/bugsnag'

import courseLogic from '~/scenes/course/show/logic'

import controller from './controller.rb'

export default kea({
  connect: {
    actions: [
      courseLogic,
      [
        'translateCourse',
        'translateProfile',
        'translateReview',
        'gotReviewTranslation',
        'gotTranslation',
        'enableSharing',
        'disableSharing',
        'updateAvailabilityTimezone',
        'updateCourseAvailability'
      ]
    ],
    props: [courseLogic, ['course']]
  },

  takeLatest: ({ actions, workers }) => ({
    [actions.translateCourse]: workers.translateCourse,
    [actions.translateProfile]: workers.translateProfile,
    [actions.translateReview]: workers.translateReview,
    [actions.enableSharing]: workers.toggleBodyScroll,
    [actions.disableSharing]: workers.toggleBodyScroll,
    [actions.updateAvailabilityTimezone]: workers.updateAvailabilityTimezone
  }),

  workers: {
    toggleBodyScroll (action) {
      const { enableSharing, disableSharing } = this.actions

      const matching = {
        [enableSharing]: () => 'hidden',
        [disableSharing]: () => 'unset'
      }

      const body = document.querySelector('body')
      if (body) {
        body.setAttribute('style', `overflow: ${matching[action.type](action.payload)}`)
      }
    },

    * translateCourse (action) {
      const { gotTranslation } = this.actions
      const { locale } = action.payload

      const course = yield courseLogic.get('course')

      try {
        const response = yield controller.index({ id: course.id, locale, profile_locale: course.profileLocale })

        if (response.error) {
          Bugsnag.notify('Kea error!', 'weird stuff', { caller: controller.index.toString() })
        } else {
          yield put(gotTranslation(response.course))
        }
      } catch (error) {
        messg.error(`${I18n.t('profile.translation.error')}:(`, 2500)
        Bugsnag.notify(error)
      }
    },

    * translateProfile (action) {
      const { gotTranslation } = this.actions
      const { locale } = action.payload

      const course = yield courseLogic.get('course')

      try {
        const response = yield controller.index({ id: course.id, locale: course.locale, profile_locale: locale })

        if (response.error) {
          Bugsnag.notify('Kea error!', 'weird stuff', { caller: controller.index.toString() })
        } else {
          yield put(gotTranslation(response.course))
        }
      } catch (error) {
        messg.error(`${I18n.t('profile.translation.error')}:(`, 2500)
        Bugsnag.notify(error)
      }
    },
    * translateReview (action) {
      const { gotReviewTranslation } = this.actions
      const { reviewId, locale } = action.payload

      try {
        const response = yield controller.translateReview({ id: reviewId, locale })

        if (response.error) {
          Bugsnag.notify('Kea error!', 'weird stuff', { caller: controller.index.toString() })
        } else {
          yield put(gotReviewTranslation(response.review))
        }
      } catch (error) {
        messg.error(`${I18n.t('profile.translation.error')}:(`, 2500)
        Bugsnag.notify(error)
      }
    },
    * updateAvailabilityTimezone (action) {
      const { updateCourseAvailability } = this.actions
      const { timezone } = action.payload
      const course = yield courseLogic.get('course')

      try {
        const response = yield controller.updateCourseAvailability({ id: course.id, timezone: timezone })

        if (response.error) {
          Bugsnag.notify('Kea error!', 'weird stuff', { caller: controller.index.toString() })
        } else {
          yield put(updateCourseAvailability(response.availability))
        }
      } catch (error) {
        messg.error('Sorry, there was an error while translating :(', 2500)
        Bugsnag.notify(error)
      }
    }
  }
})
